export const UTC = "UTC";

export const UK_SUMMERTIME_OFFSET = "+01:00";

export const OFFSET_FORMAT = "xxx";

export const UK_TIME_ZONE = "Europe/London";
